export const STOCK_STATUS = {
  AVAILABLE: 'light-green',
  AVAILABLE_IN_WAREHOUSE: 'blue',
  AVAILABLE_IN_SH: 'purple',
  ORDERED_AT_SUPPLIER: 'yellow',
  UNAVAILABLE: 'red'
}

export const WAREHOUSE_REFERENCE = 'WH'
export const BACK_ORDER_REFERENCE = 'BO'
